import { inject, makeStateKey, TransferState } from "@angular/core";
import { forkJoin, of } from "rxjs";
import { IPostModel } from "../models/post.model";
import { switchMap } from "rxjs/operators";
import { TServiceResult } from "@shared/helper/t-service-result";
import { LocalRepository } from "@shared/helper/local-repository";
import {  ResolveFn } from "@angular/router";
import { PostAggService } from "../services/postAggrigator.service";

import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";

export const STATE_KEY_POST = makeStateKey<PostResolverData>('Post_Resolver_Data');


export const PostDetailResolver: ResolveFn<PostResolverData> = (route) => {
    const suggestedPostsTermFilter: TermFilterModel = new TermFilterModel();
    const guestPostsTermFilter: TermFilterModel = new TermFilterModel();
    const serverState: TransferState = inject(TransferState);
    const _localRepository: LocalRepository = inject(LocalRepository);
    const postAggrService: PostAggService = inject(PostAggService);
    guestPostsTermFilter.pgNumber = 0;
    guestPostsTermFilter.pgSize = 3;
    suggestedPostsTermFilter.pgNumber = 0;
    suggestedPostsTermFilter.pgSize = 3;
    if (!_localRepository.IsInBrowser) {
        return postAggrService.getPost(route.paramMap.get('id')!)
            .pipe(
                switchMap(postResult =>
                    forkJoin({
                        post: postResult != undefined ? of(postResult) : of(new TServiceResult<IPostModel | null>(null, '', null, true, '')),
                        userPosts: postAggrService.getGuestPosts(postResult?.result?.actor?.id!, guestPostsTermFilter),
                        suggestedPosts: postAggrService.getSuggestedPosts(postResult?.result?.id!, suggestedPostsTermFilter),
                    })
                ),
                switchMap(forkedData => {
                    const prd = PostResolverData.instance(forkedData);
                    serverState.set(STATE_KEY_POST, prd);
                    return of(forkedData as PostResolverData);
                })
            );
    }
    return serverState.get(STATE_KEY_POST, PostResolverData.instanceAllError())
}

export class PostResolverData {
    post!: TServiceResult<IPostModel>;
    userPosts!: TServiceResult<PageList<IPostModel>>;
    suggestedPosts!: TServiceResult<PageList<IPostModel>>;

    public static instance(prd: any): PostResolverData {
        const data = new PostResolverData();
        data.post = prd.book?.hasError == true ? new TServiceResult<IPostModel | null>(null, '', null, true, '') : prd.post;
        data.userPosts = prd.posts?.hasError == true ? new TServiceResult<PageList<IPostModel>>(new PageList(), '', null, true, '') : prd.userPosts;
        data.suggestedPosts = prd.shopLinks?.hasError == true ? new TServiceResult<PageList<IPostModel>>(new PageList(), '', null, true, '') : prd.suggestedPosts;
        return data;
    }

    public static instanceAllError(): PostResolverData {
        const data = new PostResolverData();
        data.post = new TServiceResult<any>(null, '', null, true, '');
        data.userPosts = new TServiceResult<any>(null, '', null, true, '');
        data.suggestedPosts = new TServiceResult<any>(null, '', null, true, '');
        return data;
    }
}